import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE, replace } from 'react-router-redux';
import { SubmissionError, getFormValues, getFormInitialValues, change } from 'redux-form';
import qs from 'qs';

import cloneDeep from 'lodash/cloneDeep';
import orderBy from 'lodash/orderBy';
import values from  'lodash/values';
import get from 'lodash/get';
import forEach from 'lodash/forEach';
import _mapKeys from 'lodash/mapKeys';

import http from '../shared/http';
import intl from '../shared/intl';
import checkIsExcludedCountryCode from '../shared/checkIsExcludedCountryCode';

import {
	createSelectOptionsFromSysEnums
} from '../shared/form-elements/select';
import checkPermissions from '../shared/check-permissions';

// actions types
const FETCH_DATA_SUCCESS = 'geo-payout-rates/fetch-data-success';
const FETCH_DATA_ERROR = 'geo-payout-rates/fetch-data-error';

const SUBMIT_SUCCESS = 'geo-payout-rates/submit-success';
const SUBMIT_ERROR = 'geo-payout-rates/submit-error';

const UPDATE_INITIAL_FORM_DATA = 'geo-payout-rates/update-initial-form-data';

const REMOVE_SUCCESS = 'geo-payout-rates/remove-success';
const REMOVE_ERROR = 'geo-payout-rates/remove-error';

const SORT_BY_COLUMN = 'geo-payout-rates/table-sort-by-column';
const SHOW_MORE_ROWS = 'geo-payout-rates/table-show-more-rows';

const TOGGLE_PROGRESS_BAR = 'geo-payout-rates/toggle-progress-bar';

const FETCH_OFFERS_SUCCESS = 'geo-payout-rates/fetch-offers-success';
const FETCH_OFFERS_ERROR = 'geo-payout-rates/fetch-offers-error';

const FETCH_GEOS_SUCCESS = 'geo-payout-rates/fetch-offers-success';
const FETCH_GEOS_ERROR = 'geo-payout-rates/fetch-offers-error';

const FETCH_AFFILIATES_SUCCESS = 'geo-payout-rates/fetch-affiliates-success';
const FETCH_AFFILIATES_ERROR = 'geo-payout-rates/fetch-affiliates-error';

// permissions
export const allowedPermissions = {
	'geoPayoutRatesList': 'geo_payout_rates_view',
	'geoPayoutRatesEdit': 'geo_payout_rates_edit'
};

// initial state
const initialState = {
	data: null,
	showProgressBar: false,
	table: {
		columns: {
			offer: {
				index: 'offer',
				title: 'Offer',
				direction: 'asc'
			},
			geo: {
				index: 'geo',
				title: 'Geo',
				direction: 'asc'
			},
			region: {
				index: 'region_name',
				title: 'Region',
				direction: 'asc'
			},
			district: {
				index: 'district',
				title: 'District',
				direction: 'asc'
			},
			city: {
				index: 'city_name',
				title: 'City',
				direction: 'asc'
			},
			affiliate: {
				index: 'affiliate',
				title: 'Affiliate',
				direction: 'asc'
			},
			amount_usd: {
				index: 'amount_usd',
				title: 'Amount usd'
			},
			actions: {
				title: 'Actions'
			}
		},
		sortByColumn: {
			index: 'offer',
			title: 'Offer',
			direction: 'asc'
		},
		rowsNumber: 1000
	},
	form: {
		offer_id: null,
		affiliate_id: null,
		country_code: null,
		crm_region_id: null,
		crm_city_id: null,
		crm_district_id: null,
		usd_payout: null,
		rub_payout: null
	},
	error: false
};

// actions
export const actions = Object.assign(
	{
		fetchData: (props) => (dispatch, getState) => {
			(http({
				url: 'v2/geo-payout-rates',
				method: 'get',
				actions: [
					FETCH_DATA_SUCCESS,
					FETCH_DATA_ERROR
				]
			}))(dispatch);
		},
		updateInitialFormData: row => (dispatch, getState) => {
			const payoutCurrencies = selectors.getPayoutCurrencies(getState());

			const initialData = {
				ids: row.ids,
				offer_id: [{value: row.offer_id, label: row.offer}],
				affiliate_id: [{value: row.affiliate_id, label: row.affiliate}],
				country_code: [{value: row.country_code, label: row.geo}],
				crm_region_id: [{value: row.crm_region_id, label: row.region_name}],
				crm_district_id: [{value: row.crm_district_id, label: row.district_name}],
				crm_city_id: [{value: row.crm_city_id, label: row.city_name}],
				...payoutCurrencies.reduce((acc, val) => {
					acc[`${val}_payout`] = row[`${val}_payout`]; return acc;
				}, {})
			};

			dispatch({
				type: UPDATE_INITIAL_FORM_DATA,
				payload: initialData
			});
		},
		submitForm: (formData) => (dispatch, getState) => {
			const formInitialData = getFormInitialValues('geoPayoutRatesForm')(getState());
			const payoutParams = getFormParams(formData);
			const isWithInitialParams = !formInitialData.ids || !formInitialData.ids.length;

			const data = selectors.getPayoutCurrencies(getState()).map(currency => ({
				...payoutParams, value: formData[`${currency}_payout`] || 0, currency: currency.toUpperCase()
			}));

			const submitData = { ids: isWithInitialParams ? null : formInitialData.ids, data: data };

			const request = http({
				url: 'v2/geo-payout-rates',
				method: 'post',
				actions: [
					SUBMIT_SUCCESS,
					SUBMIT_ERROR
				],
				data: submitData
			});

			return request(dispatch)
				.then(action => {
					if (action.type === SUBMIT_SUCCESS) {
						dispatch(actions.redirectToModuleIndex());
					} else if (action.payload.response.status === 400) {
						throw new SubmissionError(
							getVadationErrors(action.payload.response.data, submitData)
						);
					}
				});
		},

		remove: row => dispatch => {
			const query = qs.stringify({ ids: row.ids });
			const request = http({
				url: `v2/geo-payout-rates?${query}`,
				method: 'delete',
				actions: [
					REMOVE_SUCCESS,
					REMOVE_ERROR
				]
			});

			dispatch(actions.toggleProgressBar());

			request(dispatch);
		},

		redirectToModuleIndex: () => dispatch => {
			setTimeout(() => dispatch(replace('geo-payout-rates/')), 100);
		},

		sortByColumn: columnIndex => ({
			type: SORT_BY_COLUMN,
			payload: columnIndex
		}),

		showMoreRows: () => ({
			type: SHOW_MORE_ROWS
		}),

		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		}),

		resetGeoAndAffiliate: () => dispatch => {
			dispatch(change('geoPayoutRatesForm', 'country_code', null));
			dispatch(change('geoPayoutRatesForm', 'affiliate_id', null));
		},

		loadOffersLookup: text => dispatch => {
			const request = http({
				url: `v2/lookups/offers?query=${text}`,
				method: 'get',
				actions: [
					FETCH_OFFERS_SUCCESS,
					FETCH_OFFERS_ERROR
				]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_OFFERS_SUCCESS) {
					return {
						options: createSelectOptionsFromSysEnums(action.payload.data)
					};
				}
			});
		},

		loadGeosLookup: text => (dispatch, getState) => {
			const offer_id = selectors.getSelectedOffer(getState()) || null;
			const affiliate_id = selectors.getSelectedAffiliate(getState()) || null;
			const query = qs.stringify({query: text, offer_id, affiliate_id });
			const request = http({
				url: `v2/lookups/locations-with-traffic?${query}`,
				method: 'get',
				actions: [
					FETCH_GEOS_SUCCESS,
					FETCH_GEOS_ERROR
				]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_GEOS_SUCCESS) {
					const data = action.payload.data
						.filter(entity => !checkIsExcludedCountryCode(entity.country_code));

					return {
						options: createSelectOptionsFromSysEnums(data.map(d => ({...d, id: d.country_code})))
					};
				}
			});
		},

		loadCrmGeosLookup: (type, text) => (dispatch, getState) => {
			const country_code = selectors.getSelectedGeo(getState()) || null;
			const region_id = selectors.getSelectedRegion(getState()) || null;
			const district_id = selectors.getSelectedDistrict(getState()) || null;
			if (!country_code) {
				alert('Need to select country first');
				return Promise.resolve({ options: [] });
			}
			if ( type === 'city' && !region_id) {
				alert('Need to select region first');
				return Promise.resolve({ options: [] });
			}

			const query = qs.stringify({
				query: text, country_id: country_code.toLowerCase(), region_id, district_id
			});

			const request = http({
				url: `v2/lookups/crm-locations/${type}?${query}`,
				method: 'get',
				actions: [
					FETCH_GEOS_SUCCESS,
					FETCH_GEOS_ERROR
				]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_GEOS_SUCCESS) {
					return {
						options: getCrmLocationOptions(action.payload.data)
					};
				}
			});
		},

		loadAffiliatesLookup: text => (dispatch, getState) => {
			const offer_id = selectors.getSelectedOffer(getState());
			const country_code = selectors.getSelectedGeo(getState());

			const query = qs.stringify({
				query: text,
				offer_id,
				country_code
			});
			const request = http({
				url: `v2/lookups/affiliates?${query}`,
				method: 'get',
				actions: [
					FETCH_AFFILIATES_SUCCESS,
					FETCH_AFFILIATES_ERROR
				]
			});

			return request(dispatch).then(action => {
				if (action.type === FETCH_AFFILIATES_SUCCESS) {
					return {
						options: createSelectOptionsFromSysEnums(action.payload.data)
					};
				}
			});
		}
	}
);

// reducers
const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			if (
				action.payload.pathname === 'geo-payout-rates/'
			) {
				return initialState;
			}

			return state;
		},
		[FETCH_DATA_SUCCESS]: (state, action) => {
			return { ...state, data: action.payload.data, showProgressBar: false, error: false };
		},
		[UPDATE_INITIAL_FORM_DATA]: (state, action) => {
			return { ...state, form: action.payload };
		},
		[FETCH_DATA_ERROR]: (state, action) => ({ ...state, error: true, showProgressBar: false }),
		[SORT_BY_COLUMN]: (state, action) => {
			const { sortByColumn, columns }  = state.table;
			const columnIndex = action.payload;
			const direction = sortByColumn['index'] == columnIndex ?
				sortByColumn.direction === 'desc' ? 'asc' : 'desc' :
				columns[columnIndex].direction;

			return {
				...state,
				table: {
					...state.table,
					sortByColumn: {
						...columns[columnIndex],
						direction
					}
				}
			};
		},
		[SHOW_MORE_ROWS]: state => ({
			...state,
			table: {
				...state.table,
				rowsNumber: state.table.rowsNumber + initialState.table.rowsNumber
			}
		}),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar }),
		[REMOVE_SUCCESS]: state => ({...state, data: null}),
		[REMOVE_ERROR]: state => ({...state, error: true}),
		[SUBMIT_ERROR]: (state, action) => {
			const { response: {status = null, data = null} } = action.payload;
			if (status === 400 && !!data) return state;
			return { ...state, error: true };
		}
	}
);
export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.geoPayoutRates.data,
	getPayoutCurrencies: state => state.root.lists['payout-currencies'].map(currency => currency.id),
	getSelectedOffer: state => get(getFormValues('geoPayoutRatesForm')(state), 'offer_id.0.value'),
	getSelectedGeo: state => get(getFormValues('geoPayoutRatesForm')(state), 'country_code.0.value'),
	getSelectedRegion: state => get(getFormValues('geoPayoutRatesForm')(state), 'crm_region_id.0.value'),
	getSelectedDistrict: state => get(getFormValues('geoPayoutRatesForm')(state), 'crm_district_id.0.value'),
	getSelectedAffiliate: state => get(getFormValues('geoPayoutRatesForm')(state), 'affiliate_id.0.value'),
	getGeoPayoutRate: state =>state.geoPayoutRates.form,
	getTable: state => {
		const { table, data } = state.geoPayoutRates;
		const rows = data ? sortColumns(data, table.sortByColumn) : [];
		return {
			headers: values(table.columns),
			rows: rows,
			sortedColumn: table.sortByColumn,
			rowsNumber: table.rowsNumber,
			totalRows: rows.length
		};
	},
	getIntl: state => intl(state),
	getProgressBar: state => state.geoPayoutRates.showProgressBar,
	getCan: state => checkPermissions(state, allowedPermissions),
	getError: state => state.geoPayoutRates.error
};

// functions
const sortColumns = (rows, sortedColumn) => {
	if (!rows) return null;
	return orderBy(rows, row => row[sortedColumn.index], sortedColumn.direction);
};

function getFormParams(formData) {
	return {
		offer_id: get(formData, 'offer_id.0.value', null),
		country_code: get(formData, 'country_code.0.value', null),
		crm_region_id: get(formData, 'crm_region_id.0.value', null),
		region_name: get(formData, 'crm_region_id.0.label', null),
		crm_district_id: get(formData, 'crm_district_id.0.value', null),
		district_name: get(formData, 'crm_district_id.0.label', null),
		crm_city_id: get(formData, 'crm_city_id.0.value', null),
		city_name: get(formData, 'crm_city_id.0.label', null),
		affiliate_id: get(formData, 'affiliate_id.0.value', null)
	};
}

function getVadationErrors(responseErrors, submitData) {
	const validationsErrors = {};
	forEach(responseErrors, value => {
		const key = value.dataPath.slice(1);
		if (key.includes('.amount')) {
			validationsErrors[
				`${get(submitData, key.replace('amount', 'currency'))}_payout`
			] = value.message;
		}
		if (key.includes('params.')) {
			validationsErrors[key.replace('params.', '')] = value.message;
		}
	});
	return validationsErrors;
}

function getCrmLocationOptions(locationsInput = []) {
	return createSelectOptionsFromSysEnums(locationsInput.map(l => {
		return _mapKeys(l, (val, key) => key.endsWith('id') ? 'id' : 'title');
	}));
}



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/geo-payout-rates/index.js